import { selectSettings } from '@/ducks/common/settings/selectors';
import { selectCelebrationsIsFlowActive } from '@/ducks/programs/celebrations/selectors';
import createMemoSelector from '@/helpers/createMemoSelector';

export const selectShareUrlShareType = createMemoSelector(
  selectSettings,
  selectCelebrationsIsFlowActive,
  (configServiceData, isCelebrationFlowActive) => ({
    shareType: isCelebrationFlowActive ? 'P' : configServiceData?.shareType,
    shareUrl: isCelebrationFlowActive ? configServiceData?.celebrationURL : configServiceData?.shareUrl,
  }),
);
